<template>
    <div class="general">
        <div class="row" v-if="settings">
            <div class="col-lg-12">
                <div class="box coverage">
                    <div class="box__title">
                        Dækningsgrad (DG)
                    </div>
                    <div class="options">
                        <div class="option">
                            <div class="fake-input">
                                <b>0 - {{ settings.coverage_percent.medium.value - 1 }} %</b>
                            </div>
                            <div class="name">
                                <div class="coverage-indicator bad" />
                                Utilfredsstillende
                            </div>
                            <div class="small">
                                DG vil være <span class="color bad">rød</span>, hvis den er i dette interval
                            </div>
                        </div>
                        <div class="option">
                            <input
                                type="number"
                                v-model="settings.coverage_percent.medium.value"
                                name="coverage_percent_medium"
                                min="0"
                                max="80"
                                step="1"
                                pattern="\d*" maxlength="2"
                            />
                            <b> - {{ settings.coverage_percent.high.value - 1 }} %</b>
                            <div class="name">
                                <div class="coverage-indicator avg" />
                                Middel
                            </div>
                            <div class="small">
                                DG vil være <span class="color avg">gul</span>, hvis den er i dette interval
                            </div>
                        </div>
                        <div class="option">
                            <input
                                type="number"
                                v-model="settings.coverage_percent.high.value"
                                name="coverage_percent_high"
                                min="0"
                                max="80"
                                step="1"
                                pattern="\d*" maxlength="2"
                            />
                            <b> - 100 %</b>
                            <div class="name">
                                <div class="coverage-indicator good" />
                                Tilfredsstillende
                            </div>
                            <div class="small">
                                DG vil være <span class="color good">grøn</span>, hvis den er i dette interval
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" v-if="settings">
            <div class="col-lg-12">
                <div class="box coverage">
                    <div class="box__title">
                        Dækningsbidrag (DB) pr. time
                    </div>
                    <div class="options">
                        <div class="option">
                            <div class="fake-input">
                                <b>0 - {{ settings.coverage_per_hour.medium.value - 1 }} kr.</b>
                            </div>
                            <div class="name">
                                <div class="coverage-indicator bad" />
                                Utilfredsstillende
                            </div>
                            <div class="small">
                                DB pr. time vil være <span class="color bad">rød</span>, hvis den er i dette interval
                            </div>
                        </div>
                        <div class="option">
                            <input
                                type="number"
                                v-model="settings.coverage_per_hour.medium.value"
                                name="coverage_per_hour_medium"
                                min="0"
                                max="8000"
                                step="1"
                                pattern="\d*" maxlength="4"
                            />
                            <b> - {{ settings.coverage_per_hour.high.value - 1 }} kr.</b>
                            <div class="name">
                                <div class="coverage-indicator avg" />
                                Middel
                            </div>
                            <div class="small">
                                DB pr. time vil være <span class="color avg">gul</span>, hvis den er i dette interval
                            </div>
                        </div>
                        <div class="option">
                            + 
                            <input
                                type="number"
                                v-model="settings.coverage_per_hour.high.value"
                                name="coverage_per_hour_high"
                                min="0"
                                max="8000"
                                step="1"
                                pattern="\d*" maxlength="4"
                            />
                            <b> kr.</b>
                            <div class="name">
                                <div class="coverage-indicator good" />
                                Tilfredsstillende
                            </div>
                            <div class="small">
                                DB pr. time vil være <span class="color good">grøn</span>, hvis den er over dette tal
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <div class="row" v-if="settings">
            <div class="col-lg-12">
                <div class="box coverage">
                    <div class="box__title">
                        Registreret tid
                    </div>
                    <div class="options">
                        <div class="option">
                            <div class="fake-input">
                                <b>0 - {{ settings.timelogging.medium.value - 1 }} %</b>
                            </div>
                            <div class="name">
                                <div class="coverage-indicator bad" />
                                Utilfredsstillende
                            </div>
                            <div class="small">
                                Registreret tid vil være <span class="color bad">rød</span>, hvis den er i dette interval
                            </div>
                        </div>
                        <div class="option">
                            <input
                                type="number"
                                v-model="settings.timelogging.medium.value"
                                name="coverage_percent_medium"
                                min="0"
                                max="80"
                                step="1"
                                pattern="\d*" maxlength="2"
                            />
                            <b> - {{ settings.timelogging.high.value - 1 }} %</b>
                            <div class="name">
                                <div class="coverage-indicator avg" />
                                Middel
                            </div>
                            <div class="small">
                                Registreret tid vil være <span class="color avg">gul</span>, hvis den er i dette interval
                            </div>
                        </div>
                        <div class="option">
                            <input
                                type="number"
                                v-model="settings.timelogging.high.value"
                                name="coverage_percent_high"
                                min="0"
                                max="80"
                                step="1"
                                pattern="\d*" maxlength="2"
                            />
                            <b> - 100 %</b>
                            <div class="name">
                                <div class="coverage-indicator good" />
                                Tilfredsstillende
                            </div>
                            <div class="small">
                                Registreret tid vil være <span class="color good">grøn</span>, hvis den er i dette interval
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <div class="row" v-if="settings">
            <div class="col-lg-12">
                <div class="box coverage">
                    <div class="box__title">
                        Beregning af medarbejdernes indtjening
                    </div>
                    <div class="row">
                        <div class="col-lg-6">
                            <div class="inside">
                                <div style="display:flex;">
                                    <span style="display:block;width:1.4em;"><input type="radio" name="employee-calculation" value="responsible" v-model="employeeCalc" @change="selectEmployeeCalc('responsible')" /></span>
                                    <span style="margin-left:10px;">Indtjening tilfalder den medarbejder, der har arbejdet mest på opgaven</span>
                                </div>
                                <div class="options">
                                    <div class="option fw">
                                        <input
                                            type="number"
                                            v-model="settings.main_employee_percent"
                                            name="main_employee_percent"
                                            min="50"
                                            max="99"
                                            step="1"
                                            pattern="\d*" maxlength="2"
                                        /> <b>%</b>
                                    </div>
                                </div>
                                <i>Bemærk, at en ændring i dette felt først træder ikraft næste dag.</i>
                                <div class="small">
                                    Her fastsættes, hvor stor en andel af det samlede antal timer på en opgave, som skal være udført af 1 svend, før indtjeningen tildeles 1 svend. Andelen kan ikke komme under 50%
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="inside">
                                <div style="display:flex;">
                                    <span style="display:block;width:1.4em;"><input type="radio" name="employee-calculation" value="calculation" v-model="employeeCalc" @change="selectEmployeeCalc('calculation')" /></span>
                                    <span style="margin-left:10px;">Indtjening fordeles ud fra antal timer lagt i en opgave</span>
                                </div>
                                <div class="small">
                                    De enkelte opgavers omsætning/omkostning/indtjening fordeles forholdsmæssigt på ALLE medarbejdere, som har arbejdet på opgaven. Hvis f.eks. “Mads” har udført 30% af timerne, tildeles han 30% af indtjeningen.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="text-align:center;margin-top:15px;font-size:14px;">
                        Bemærk, at ændringerne for begge ovenstående beregninger først træder ikraft næste dag.
                    </div>
                    <!--<div class="options">
                        <div class="option fw">
                            <input
                                type="number"
                                v-model="settings.main_employee_percent"
                                name="main_employee_percent"
                                min="50"
                                max="99"
                                step="1"
                                pattern="\d*" maxlength="2"
                            /> <b>%</b>
                            <div class="small">
                                Her fastsættes, hvor stor en andel af den samlede antal timer på en opgave, der skal være udført af 1 svend, før du betragter opgaven som udført af 1 person. Tallet bliver brugt til at udregne, hvor effektiv den enkelte svend er til at udføre en bestemt type opgave. Bemærk, at ændringen først træder i kraft næste dag, når data er blevet synkroniseret igen. Af tekniske årsager kan denne værdi ikke være lavere end 50%.
                            </div>
                        </div>
                    </div>-->
                </div>
            </div>
        </div>
        <div class="row" v-if="settings">
            <div class="col-lg-6">
                <div class="box coverage">
                    <div class="box__title">
                        Fakturaer med overskredet betaling
                    </div>
                    <div class="options">
                        <div class="option fw">
                            <input
                                type="number"
                                v-model="settings.overdue_days"
                                name="overdue_days"
                                min="0"
                                max="99"
                                step="1"
                                pattern="\d*" maxlength="2"
                            /> <b>dage</b>
                            <div class="small">
                                Her fastsættes, hvor mange dage betalingsfristen må være overskredet, før den skal vises på oversigten.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="box coverage">
                    <div class="box__title">
                        Opgaver uden bevægelse
                    </div>
                    <div class="options">
                        <div class="option fw">
                            <input
                                type="number"
                                v-model="settings.snoozed_days"
                                name="snoozed_days"
                                min="0"
                                max="99"
                                step="1"
                                pattern="\d*" maxlength="2"
                            /> <b>dage</b>
                            <div class="small">
                                Her fastsættes, hvor mange dage der må gå uden registrering af timer eller materialer på en opgave, før den skal vises på oversigten.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12" align="right">
                <div class="pretty-button inverse" @click="doReset()">
                    <i class="far fa-history fa-fw" />
                    Gendan standardindstillinger
                </div>
                <div class="pretty-button" @click="doSave()">
                    <i class="far fa-save fa-fw" />
                    Gem
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import "../../../styles/vars.scss";

    .inside {
        padding: $padding--small;
        background: rgba(0, 0, 0, 0.05);
        border-radius: $borderradius--main;
        font-size: $fontsize--small * 1.1;
        font-weight: 600;
        height: 100%;

        input[type=radio] {
            border: 0px;
            width: 100%;
            height: 1.4em;
        }

        .small {
            margin-top: $margin--main / 2;
            font-size: $fontsize--small * 1.1;
            font-weight: normal;
        }
    }

    .box {
        background: $color--white;
        padding: $padding--main;
        border-radius: $borderradius--main;
        box-shadow: $boxshadow--creative;

        &__title {
            font-weight: $fontweight--bold;
            font-family: $fontfamily--main;
            margin-bottom: $margin--main;
            text-align: center;
        }

        .options {
            display: flex;
            justify-content: space-between;

            .option {
                flex: 0 0 30%;
                text-align: center;

                &.fw {
                    flex: 0 0 100%;
                }

                input {
                    border: 1px solid rgba(0, 0, 0, 0.15);
                    border-radius: $borderradius--main;
                    width: 50px;
                    height: 40px;
                    text-align: center;
                    font-weight: bold;
                    margin: $margin--small 0;
                    background: $color--white;
                }

                .small {
                    font-size: $fontsize--small;
                    margin-top: $margin--small;
                }

                .fake-input {
                    height: 40px;
                    line-height: 40px;
                    margin: $margin--small 0;
                }
            }
        }
    }

</style>

<script>
import * as settingsService from '@/services/settingsService'
import * as companyService from '@/services/companyService'

export default {
    data () {
        return {
            settings: null,
            employeeCalc: null
        }
    },
    mounted () {
        this.setSettings()
        this.getEmployeeCalc()
    },
    methods: {
        getEmployeeCalc () {
            companyService.employeeCalc({}, (response) => {
                this.employeeCalc = response.data
            }, (err) => {
                console.log(err)
            })
        },
        selectEmployeeCalc (type) {
            if (this.$auth.user().company.demo_company && this.$auth.user().roles[0].name !== 'super-admin') {
                alert('Det er ikke muligt at ændre denne indstilling i demo-versionen.')
                return
            }
            let body = {
                employeeCalc: type
            }
            companyService.updateEmployeeCalc(body, (response) => {
                console.log(response)
                this.getEmployeeCalc()
                // this.$toastr('success', 'Medarbejder indtjening indstillingen blev opdateret', 'Sådan!')
            }, (err) => {
                console.log(err)
            })
        },
        setSettings () {
            this.settings = JSON.parse(JSON.stringify(this.$store.state.config.companyMeta.settings))
        },
        doSave () {
            if (this.$auth.user().company.demo_company && this.$auth.user().roles[0].name !== 'super-admin') {
                alert('Det er ikke muligt at ændre denne indstilling i demo-versionen.')
                return
            }
            if (this.settings.main_employee_percent < 50) {
                alert('Værdien i feltet "Hvornår kan en opgave betragtes som værende udført af 1 svend?" er for lav. Angiv venligst minimum 50%.')
                return
            }
            let body = {
                coverage_percent: {
                    medium: {value: this.settings.coverage_percent.medium.value},
                    high: {value: this.settings.coverage_percent.high.value}
                },
                coverage_per_hour: {
                    medium: {value: this.settings.coverage_per_hour.medium.value},
                    high: {value: this.settings.coverage_per_hour.high.value}
                },
                timelogging: {
                    medium: {value: this.settings.timelogging.medium.value},
                    high: {value: this.settings.timelogging.high.value}
                },
                main_employee_percent: this.settings.main_employee_percent,
                overdue_days: this.settings.overdue_days,
                snoozed_days: this.settings.snoozed_days
            }
            settingsService.update(body, (response) => {
                this.$toastr('success', 'Indstillingerne blev opdateret', 'Sådan!')
                setTimeout(() => {
                    window.location.href = '/'
                }, 1000)
            }, (err) => {
                console.log(err)
            })
        },
        doReset () {
            if (this.$auth.user().company.demo_company && this.$auth.user().roles[0].name !== 'super-admin') {
                alert('Det er ikke muligt at ændre denne indstilling i demo-versionen.')
                return
            }
            settingsService.update({}, (response) => {
                this.$toastr('success', 'Indstillingerne blev gendannet', 'Sådan!')
                setTimeout(() => {
                    window.location.href = '/'
                }, 1000)
            }, (err) => {
                console.log(err)
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// general.vue?3bf5f236